import {Component, EventEmitter, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Vehicle} from '../../models/vehicle';
import {VehiclesHandlerService} from '../../api-handlers/vehicles-handler.service';
import {TechnicalShutdown} from '../../models/technical_shutdown';
import {CreateFermoTecnicoComponent} from '../create-fermo-tecnico/create-fermo-tecnico.component';
import {DateHandlerService} from '../../commons/date-handler.service';

@Component({
	selector: 'app-fermi-tecnici',
	templateUrl: './fermi-tecnici.component.html',
	styleUrls: ['./fermi-tecnici.component.css']
})
export class FermiTecniciComponent implements OnInit {
	@ViewChild('template', {static: false}) template;
	@Output() createRequested = new EventEmitter();
	modalRef: BsModalRef;
	vehicle: Vehicle;
	dom_elements = { };

	listaStoricoFermoTecnico: TechnicalShutdown[];

	constructor(
		private modalService: BsModalService,
		private dateHandler: DateHandlerService,
		private vehicleHandler: VehiclesHandlerService,
		private ngZone: NgZone) { }

	ngOnInit() {
		this.resetDomElements();
		this.listaStoricoFermoTecnico = [];
	}

	resetDomElements() {
		this.dom_elements = {
			technical_shutdowns: []
		};

	}
	showDialog(vehicle: Vehicle) {
		this.vehicle = vehicle;
		this.modalRef = this.modalService.show(this.template, { class: 'modal-lg' });
		this.reload();
		this.getStoricoFermiTecnici();
	}

	reload() {
		this.resetDomElements();

		this.vehicleHandler.getTechnicalShutdown(this.vehicle, true).then((technicalShutdowns: TechnicalShutdown[]) => {
			this.ngZone.run( () => {
				this.dom_elements['technical_shutdowns'] = technicalShutdowns;
			});
		});
	}

	getStoricoFermiTecnici(){
    this.vehicleHandler.getTechnicalShutdown(this.vehicle, false).then((technicalShutdowns: TechnicalShutdown[]) => {
      this.ngZone.run( () => {
        this.listaStoricoFermoTecnico = technicalShutdowns;

      });
    });
  }

	createFermo() {
		this.modalRef.hide();
		const ts = new TechnicalShutdown(null);
		ts.vehicle_id = '' + this.vehicle.id;
		ts._from = new Date();
		ts.to = new Date();
		this.createRequested.emit({'technicalShutdown': ts, 'vehicle': this.vehicle});

	}

	edit(tecnhicalShutdown: TechnicalShutdown) {
		this.modalRef.hide();
		this.createRequested.emit({'technicalShutdown': tecnhicalShutdown, 'vehicle': this.vehicle});
	}

	delete(tecnhicalShutdown: TechnicalShutdown) {
		console.log(onratechange);

		const r = confirm('Sicuro di voler cancellare il fermo tecnico?');
		if (r === true) {
			this.vehicleHandler.deleteTechnicalShutdown(tecnhicalShutdown).then((res) => {
				this.reload();
			});
			this.reload();
		}
	}
}
